window.Vivense = window.Vivense || {};

Vivense.maskUtil = (function ($) {

    var exports = {};

    var maskFormatTR = "999 999 99 99";
    var maskFormat = "9999999999999";

    /* Safari tarayıcısında input mask sonrası imleç her zaman en başa getirilemiyor.
    placeholder'ı "_" yaparak kullanıcıya formatın daha anlaşılır görünmesini sağlıyoruz.
    Boş placeholder kullanıldığında bu durum fark edilmiyor. Direkt olarak 3. karakterden mask yapmaya başlıyor. */
    var placeholder = "_";

    var areaCodes = [501, 505, 506, 507, 551, 552, 553, 554, 555, 559, 530, 531, 532, 533, 534,  535, 536, 537, 538, 539, 561, 540, 541, 542, 543, 544, 545, 546, 547, 548, 549];


    function initPhoneMask(phone, onlyTR) {
        onlyTR = typeof onlyTR !== 'undefined' ? onlyTR : false;

        var settings = {
            preferredCountries: ["tr"],
            separateDialCode: true,
            //utilsScript: '/assets/js/intl-tel-input/build/js/utils.js?v=1.0.3',
            hiddenInput: "full_phone",
            autoPlaceholder: "off"
        };

        if(onlyTR){
            settings.onlyCountries = ["tr"];
            settings.allowDropdown = false;
        }

        phone.intlTelInput(settings);

        phone.on("countrychange", function () {
            if (isTurkeySelected(phone)) {
                phone.inputmask("remove");
                initTelMaskTR(phone);
            } else {
                phone.inputmask("remove");
                initTelMaskGlobal(phone);
            }

        });

        initTelMaskTR(phone);

        //initRegex(phone);
    }

    function initTelMaskTR(phone){
        phone.inputmask(maskFormatTR, {
                placeholder: placeholder,
                allowPlus: true,
                autoUnmask: true,
                showMaskOnHover: false,
                removeMaskOnSubmit: true
            }
        );
    }

    function initTelMaskGlobal(phone){
        phone.inputmask(maskFormat, {
                placeholder: placeholder,
                allowPlus: true,
                autoUnmask: true,
                showMaskOnHover: false,
                removeMaskOnSubmit: true
            }
        );
    }

    function destroyPhone(phone){
        phone.intlTelInput('destroy');
    }

    function phoneFormatBeforeAjax(formData, inputName, phone) {
        var formattedPhone = phone.intlTelInput("getNumber").toString();

        formData.push({
            name: inputName,
            value: formattedPhone
        });
    }

    function isTurkeySelected(phone){
        return phone.intlTelInput('getSelectedCountryData').iso2 === "tr";
    }

    function initRegex(phone) {
        phone.keyup(function () {
            this.value = this.value.replace(/[^0-9.]/g,'');
        });
    }

    function isValidTurkeyPhoneNumber(phoneNumber) {
        return phoneNumber.length === 13 && isValidAreaCode(phoneNumber);
    }

    function isValidGlobalNumber(phoneNumber) {
        return phoneNumber.length >= 8 && phoneNumber.length <= 16;
    }

    function validatePhone(phoneInput) {

        var phoneNumber = phoneInput.intlTelInput("getNumber").toString();
        var isTurkeySelected = Vivense.maskUtil.isTurkeySelected(phoneInput);

        if (isTurkeySelected) {
            return isValidTurkeyPhoneNumber(phoneNumber);
        } else {
            return isValidGlobalNumber(phoneNumber);
        }
    }

    function isValidAreaCode(phoneNumber) {
        var areaCode = phoneNumber.slice(3, 6);

        if($.inArray(parseInt(areaCode), areaCodes) !== -1) {
            return true;
        }

        return false;
    }

    exports.initPhoneMask = initPhoneMask;
    exports.phoneFormatBeforeAjax = phoneFormatBeforeAjax;
    exports.destroyPhone = destroyPhone;
    exports.validatePhone = validatePhone;
    exports.isTurkeySelected = isTurkeySelected;

    return exports;
})(jQuery);
